import React from 'react';

function PipingTag({ attributes, children }) {
  return (
    <span
      className="text-black border border-chocolate-200 bg-chocolate-100 rounded mx-px px-1"
      {...attributes}
    >
      {children}
    </span>
  );
}

export default PipingTag;
